module.exports = __webpack_public_path__ + "img/physical_activity.4a8cd9ff.png";